<script>
import Swiper from "swiper/bundle";

import VIcon from "@/components/atoms/VIcon.vue";
import VPicture from "@/components/atoms/VPicture.vue";
import VVideo from "@/components/atoms/VVideo.vue";

export default {
  name: "VSwiper",
  components: {
    VIcon,
    VPicture,
    VVideo
  },
  props: {
    data: {
      type: Array,
      default: () => []
    }
  },
  mounted() {
    // Base Config
    const config = {
      loop: true,
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev"
      },
      pagination: false,
      roundLengths: true,
      scrollbar: false,
      watchOverflow: true
    };

    // Init Swiper
    new Swiper(".swiper-container", config);
  }
};
</script>

<template>
  <div class="swiper-container">
    <div class="swiper-wrapper">
      <div v-for="(item, index) in data" :key="index" class="swiper-slide">
        <VPicture v-if="item.image" :data="item.image" />
        <VVideo v-if="item.video" :data="item.video" />
      </div>
    </div>

    <button class="swiper-button-prev">
      <VIcon :data="'arrow-left'" />
    </button>

    <button class="swiper-button-next">
      <VIcon :data="'arrow-left'" />
    </button>
  </div>
</template>
